// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2VOEr","range":"MonthRangeSwitch_range__3SjUC","disabled":"MonthRangeSwitch_disabled__1mFtF"};